









import { Vue, Component } from 'vue-property-decorator'
import { TitleBlockModel } from '../models'
import TitleBlock from '../components/TitleBlock.vue'
import ItemsInstructions from '../components/ItemsInstructions.vue'

@Component({
  components: {
    TitleBlock,
    ItemsInstructions
  }
})

export default class BlockInstructions extends Vue {
  titles: TitleBlockModel = {
    title: 'Как стать самозанятым',
    subtitle: 'Пройдите простую регистрацию в&nbsp;специальном приложении для самозанятых&nbsp;&mdash; &laquo;Мой налог&raquo;, которое можно скачать в&nbsp;App&nbsp;Store или Google&nbsp;Play.'
  }
}
